import React, { Component } from "react";
import { applyDataTable } from '../../../custom/dataTable';
import Delete from '../../../../assets/img/svg/delete.svg';
import del from "../../../../assets/img/svg/Del.svg";
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from "moment"
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { CssTextField, CssTextFieldLast, CssTextFieldRow } from "../../../custom/textField"
import Select from "react-select";
import closeIcon from "../../../../assets/img/svg/closeIcon.svg";
import { roleTypeString, additionalRoles, additionalRole, yardCommonRoles, yardCommonRole, yardOwnerRole, adminRole, additionalTraining, additionalTrainings, yardMandatoryTraining, yardMandatoryTrainings } from "../../../common/commonJson";
import { characterValidation, dropDownOptions } from "../../../common/commonFunction";
import yardIcon from "../../../../assets/img/svg/yardRolesIcon.svg";

class LViewTrainings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            render: false,
            dataList: [],
            deleteId: 0,
            showrow: false,
            responseId: 0,
            index: 0,
            actNameFocus: false,
            DescNameFocus: false,
            name: "",
            typeId: [],
            nameError: false,
            searchData: {
                PageNumber: 1,
                PageSize: 100,
            },
            searchCommonData: {
                PageNumber: 1,
                PageSize: 100,
            },
            lookupData: {
                Name: "",
                PageNumber: 1,
                PageSize: 1000000,
            },
            rolesValue: [],
            trainingsOptions: [],
            FocusId: 0,
            FocusId1: 0,
            YardId: 0,
            dataListCommon: [],
            trainingsDisplay: [],
            HoverIdCommon: 0,
            FocusIdCommon: 0,
            isDisabled: false,
            trainingChange: false,
            trainingChangeRoles: [],
            paging: false,
            existId: [],
            isOnChange: false,
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        const userRole = localStorage.getItem("UserRoles");
        this.setState({ paging: true });
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData);
        this.lookupRoleData(this.state.lookupData);
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    dataTable = (data) => {
        let apiUrl = API.ACTION_COMMONTRAININGS + '?PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.dataList = [];
                    this.setState({})
                    response.data?.CommonTrainings.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.state.dataList = response.data;
                    const check = response.data?.CommonTrainings?.filter((data) => data.Title == "" && (data.TrainingRoles?.length == 0 || data.TrainingRoles?.length == undefined))
                    if (check?.length == 0) {
                        this.state.dataList?.CommonTrainings.push({
                            Id: 0,
                            Title: "",
                            TrainingRoles: [],
                        })
                    }
                    this.state.render = true;
                    this.setState({})
                    if (this.state.paging == true) {
                        setTimeout(
                            // document.getElementById("additionalTrainings").scrollIntoView(),
                            window.scrollTo(0, 0)
                            , 0)
                        this.setState({
                            paging: false
                        })
                    }
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    lookupRoleData = (data, type) => {
        let apiUrl = API.ACTION_COMMONROLES + '?Name=' + data.Name + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    const data = response?.data?.CommonRoles.filter((role) => role.Name !== "");
                    this.setState({
                        trainingsDisplay: data
                    })
                    this.setState({
                        trainingsOptions: dropDownOptions(data)?.props?.children
                    })
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#MASDATA9 .MuiListItemText-primary").addClass("spanTopBar")
        $("#MasterData9 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#MasterData99").addClass("d-none");
        $("#MasterData99").removeClass("d-block");
        $("#MTrainings").removeClass("active-color");
        $("#MTrainingsT").removeClass("fw-bolder");
    }

    sidebar = () => {
        this.props.navigate("/sidebarmasterdata");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#MASDATA9 .MuiListItemText-primary").addClass("spanTopBar")
        $("#MasterData9 .MuiListItemText-primary").addClass("fw-bolder");
        $("#MasterData99").removeClass("d-none");
        $("#MasterData99").addClass("d-block");
        $("#MTrainingsT .MuiListItemText-primary").addClass("fw-bolder");
        $("#MTrainings").addClass("active-color");
    };

    post_data = (data) => {
        let apiUrl = API.ACTION_COMMONTRAININGS;
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.dataTable(this.state.searchData);
                    let data = [];
                    let dataObj = {};
                    if (this.state.typeId?.length > 0) {
                        this.state.typeId?.map((r) => (
                            dataObj = {
                                RoleId: parseInt(r.value?.split(",")[0]),
                                RoleName: r.value?.split(",")[1]
                            },
                            data.push(dataObj)
                        ))
                    }
                    this.state.dataList?.CommonTrainings?.map((i) => (
                        i.Id == 0 ? (i.Id = response.data, i.Title = this.state.name, i.TrainingRoles = data) : <></>
                    ))
                    this.setState({})
                    this.setState({
                        name: "",
                        typeId: [],
                    })
                    this.state.nameError = false;
                    this.state.FocusId = 0;
                    this.state.FocusId1 = 0;
                    let id = this.state.dataList?.CommonTrainings.filter((i) => i.Id == 0)
                    if (id.length == 0) {
                        this.state.dataList?.CommonTrainings.push({
                            Id: 0,
                            Name: "",
                            TypeId: []
                        })
                    }
                    this.state.dataList?.CommonTrainings.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    put_data = (data, Id) => {
        let apiUrl = API.ACTION_COMMONTRAININGS + '/' + Id;
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.dataTable(this.state.searchData)
                    this.setState({ FocusId1: 0, HoverId1: 0, FocusId: 0, HoverId: 0, index: 0 })
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    OpenPopup = (Id) => {
        this.state.deleteId = Id;
        this.setState({})
        window.$("#deletepopup").modal("show")
    }

    DeleteItem = () => {
        window.$("#deletepopup").modal("hide");
        this.deleteopalookdocs(this.state.deleteId)
    }

    deleteopalookdocs = (data) => {
        let apiUrl = API.ACTION_COMMONTRAININGS + '/' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    let data = {
                        Name: "",
                        PageNumber: 1,
                        PageSize: 100,
                    };
                    this.setState({
                        searchData: data,
                    })
                    this.dataTable(data)
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    hoverHeight = (e, i) => {
        let data = $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.HoverId = i.Id;
        if (data > data1) {
            this.state.Rows = data + 1;
        }
        else {
            this.state.Rows = data1 + 1;
        }
        this.setState({})
    }

    hoverHeight1 = (e, i) => {
        let data = $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.FocusId = i.Id;
        if (data > data1) {
            this.state.Rows1 = data + 1;
        }
        else {
            this.state.Rows1 = data1 + 1;
        }
        this.setState({})
    }

    handleInputAdditionalTraining = (e, str, val, index) => {
        this.setState({
            isOnChange: true,
        })
        if (val == "Name") {
            if (characterValidation(e.target.value) == true) {
                this.state?.dataList?.CommonTrainings?.map((i) => (
                    i.Id == str.Id ? i.Title = e.target.value : <></>
                ))
            }
            if (e.target.value != "") {
                let index = this.state.existId.filter(item => item !== str.Id);
                this.setState({
                    existId: index
                })
            }
        }
        this.setState({})
    }

    handleInputAdditionalTrainingBlur = (e, str, val, index) => {
        if (val == "Name") {
            let data = {
                "AddedRoleIds": [],
                "DeletedRoleIds": [],
                "Title": e.target?.value?.trim(),
                "IsTitleModified": true,
            }
            // if (e.target?.value?.trim() == "" && (str?.TrainingRoles?.length == 0 || str?.TrainingRoles?.length == undefined)) {
            //     this.deleteopalookdocs(str.Id)
            // } else {
            this.put_data(data, str.Id)
            // }
        }
    }

    handleTrainingNameChange = (e) => {
        this.setState({
            isOnChange: true,
        })
        if (characterValidation(e.target.value) == true) {
            this.state.name = e.target.value;
            this.setState({});
        }
    }

    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.state.paging = true;
        this.setState({})
        this.dataTable(this.state.searchData)
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.state.paging = true;
        this.setState({})
        this.dataTable(this.state.searchData)
    }

    async postDataBlur(e, str, val) {
        this.setState({
            nameError: true
        })
        let dataName = e.target.value.trim();
        if (this.state.isOnChange == true) {
            this.setState({
                isOnChange: false
            })
            if ((dataName != "" && ((str.Id == 0 && this.state.typeId?.length > 0) || str.Id != 0))) {
                let url = API.verifyDuplicate_Trainings + dataName
                try {
                    let response = await axios.get(url);
                    if (response?.data == true) {
                        let index = this.state.existId.filter(item => item !== str.Id);
                        this.setState({
                            existId: index
                        })
                        let addArray = [];
                        if (this.state.typeId?.length > 0) {
                            this.state.typeId?.map((r) => (
                                addArray.push(parseInt(r?.value?.split(",")[0]))
                            ))
                        }
                        if (str.Id == 0 && this.state.typeId?.length > 0) {
                            let data = {
                                "AddedRoleIds": addArray,
                                "DeletedRoleIds": [],
                                "IsTitleModified": false,
                                "Title": e.target.value.trim()
                            }
                            this.post_data(data)
                        }
                        else if (str.Id != 0) {
                            let data = {
                                "AddedRoleIds": [],
                                "DeletedRoleIds": [],
                                "Title": e.target?.value?.trim(),
                                "IsTitleModified": true,
                            }
                            this.put_data(data, str.Id)
                        }
                    } else if (response?.data == false) {
                        let data = [...this.state.existId];
                        data.push(str.Id);
                        this.setState({
                            existId: data
                        })
                    }
                } catch (e) {

                }
            }
            else if (dataName == "") {
                if (str.Id != 0) {
                    let data = {
                        "AddedRoleIds": [],
                        "DeletedRoleIds": [],
                        "Title": e.target?.value?.trim(),
                        "IsTitleModified": true,
                    }
                    this.put_data(data, str.Id)
                }
                let index = this.state.existId.filter(item => item !== str.Id);
                this.setState({
                    existId: index
                })
            }
            this.setState({})
        } else {
            this.setState({
                HoverId: 0,
                index: 0
            })
        }
    }

    trainingOnChange = (e, val) => {
        if (this.state.trainingChange == false) {
            localStorage.setItem('trainingRoles', JSON.stringify(val?.TrainingRoles))
            this.setState({
                trainingChange: true
            })
        }
        let addArray = [];
        let removeArray = [];
        let dataArray = [];
        if (val?.TrainingRoles?.length > 0 && e?.length < val?.TrainingRoles?.length) {
            val?.TrainingRoles?.map((r) => (
                e?.filter((a) => parseInt(a?.value?.split(",")[0]) == r.RoleId)?.length === 0 ?
                    (removeArray?.push(r.RoleId),
                        dataArray = val?.TrainingRoles?.filter(object => {
                            return object.RoleId !== r.RoleId
                        }),
                        val.TrainingRoles = dataArray
                    )
                    : ""
            ))
        } else if (e?.length > 0 && val?.TrainingRoles?.length < e?.length) {
            e?.map((r) => (
                val?.TrainingRoles?.filter((a) => a.RoleId == parseInt(r?.value?.split(",")[0]))?.length === 0 ? (addArray?.push(parseInt(r?.value?.split(",")[0])),
                    val.TrainingRoles?.push({
                        RoleId: parseInt(r?.value?.split(",")[0]),
                        RoleName: r?.value?.split(",")[1]
                    })
                ) : ""
            ))
        }
        this.setState({})
    }

    trainingChange = (e, val) => {
        let TrainingRoles = JSON.parse(localStorage.getItem('trainingRoles'));

        // if (val.Title == "" && (val?.TrainingRoles?.length == 0 || val?.TrainingRoles?.length == undefined)) {
        //     this.deleteopalookdocs(val.Id)
        //     // this.state.index = 0;
        // }

        let addArray = [];
        let removeArray = [];
        let dataArray = [];
        if (val?.TrainingRoles?.length > 0 && val?.TrainingRoles?.length == TrainingRoles?.length) {
            val?.TrainingRoles?.map((r) => (
                TrainingRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (addArray?.push(parseInt(r?.RoleId))) : (removeArray?.push(parseInt(r?.RoleId))
                    )))
            TrainingRoles?.map((r) => (
                val?.TrainingRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (removeArray?.push(parseInt(r?.RoleId))) : (addArray?.push(parseInt(r?.RoleId))
                    )))
        }
        else if (TrainingRoles?.length > 0 && val?.TrainingRoles?.length < TrainingRoles?.length) {
            TrainingRoles?.map((r) => (
                val?.TrainingRoles?.filter((a) => parseInt(a?.RoleId) == r.RoleId)?.length === 0 ?
                    (removeArray?.push(r.RoleId))
                    : ""
            ))
            val?.TrainingRoles?.map((r) => (
                TrainingRoles?.filter((a) => parseInt(a?.RoleId) == r.RoleId)?.length === 0 ?
                    (addArray?.push(r.RoleId))
                    : ""
            ))
        } else if (val?.TrainingRoles?.length > 0 && TrainingRoles?.length < val?.TrainingRoles?.length) {
            val?.TrainingRoles?.map((r) => (
                TrainingRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (addArray?.push(parseInt(r?.RoleId))
                    ) : ""
            ))
            TrainingRoles?.map((r) => (
                val?.TrainingRoles?.filter((a) => a.RoleId == parseInt(r?.RoleId))?.length === 0 ?
                    (removeArray?.push(parseInt(r?.RoleId))
                    ) : ""
            ))
        }
        localStorage.removeItem('trainingRoles');
        this.setState({
            trainingChange: false,
        })
        let data = {
            "AddedRoleIds": addArray,
            "DeletedRoleIds": removeArray,
            "Title": val.Title,
            "IsTitleModified": false
        }
        this.setState({})
        this.put_data(data, val.Id)
        this.setState({ FocusId1: 0 })
    }

    setDefaultTrainings = (array) => {
        let data = [];
        this.state.trainingsOptions?.map((r) => (
            array.filter((a) => a.RoleId == parseInt(r.value?.split(',')[0]))?.length > 0 ? data.push(r) : ""
        ))
        return data;
    }

    trainingChangePost = (e, val) => {
        this.setState({
            typeId: e,
            nameError: true
        })
        // let addArray = [];
        // if (e?.length > 0) {
        //     e?.map((r) => (
        //         addArray.push(parseInt(r?.value?.split(",")[0]))
        //     ))
        // }
        // if (this.state.name?.trim() != "") {
        //     let data = {
        //         "AddedRoleIds": addArray,
        //         "IsTitleModified": false,
        //         "DeletedRoleIds": [],
        //         "Title": this.state.name?.trim()
        //     }
        // this.post_data(data)
        // }
    }

    async trainingChangePostBlur(e, val) {

        let addArray = [];
        if (this.state.typeId?.length > 0) {
            this.state.typeId?.map((r) => (
                addArray.push(parseInt(r?.value?.split(",")[0]))
            ))
        }
        if (this.state.name?.trim() != "" && this.state.typeId?.length > 0) {

            let url = API.verifyDuplicate_Trainings + this.state.name?.trim()
            try {
                let response = await axios.get(url);
                if (response?.data == true) {
                    let index = this.state.existId.filter(item => item !== val.Id);
                    this.setState({
                        existId: index
                    })
                    let addArray = [];
                    if (this.state.typeId?.length > 0) {
                        this.state.typeId?.map((r) => (
                            addArray.push(parseInt(r?.value?.split(",")[0]))
                        ))
                    }
                    let data = {
                        "AddedRoleIds": addArray,
                        "IsTitleModified": false,
                        "DeletedRoleIds": [],
                        "Title": this.state.name?.trim()
                    }
                    this.post_data(data)
                    this.setState({ FocusId1: 0 })
                } else if (response?.data == false) {
                    let data = [...this.state.existId];
                    data.push(val.Id);
                    this.setState({
                        existId: data
                    })
                }
            } catch (e) {

            }
        }

    }

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row border-bottom w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={() => this.sidebar()} >
                                            <ListItemText id="Yardroles" className='  textNaviIcon' primary="Master Data" />
                                            <NavigateNextIcon id="Yardroles1" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Trainings</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto" style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {/* Additional Trainings */}

                    <div className="row" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 p-2">
                                {this.state.isMobile ? <></> : <h6>Trainings</h6>}
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                <table id="" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="49%" style={{ minWidth: '49%', maxWidth: '49%' }}><span className="spandoc-thead">Training Title</span></th>
                                            <th className="border-top border-right" width="48%" style={{ minWidth: '48%', maxWidth: '48%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Applicable Roles</span></th>
                                            <th className="border-top border-right" onClick={() => this.setState({ content: !this.state.content })} width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.dataList?.CommonTrainings?.length > 0 ?
                                            <>{this.state?.dataList?.CommonTrainings && this.state?.dataList?.CommonTrainings?.map((i, index) => (
                                                i.Id != 0 ?
                                                    <tr className="border-top">
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left span-height align-middle`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            <div className={this.state.isDisabled ? "border-bg-none" : (this.state.HoverId == i.Id || this.state.index == i.Id || i.Title == "" || this.state.existId?.includes(i.Id) == true) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id={"actName" + i.Id}
                                                                    disabled={this.state.isDisabled}
                                                                    onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverId: 0 })}
                                                                    // style={{ height: $("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight() ? $("#actName" + i.Id).outerHeight() + 13 : $("#actDesc" + i.Id).outerHeight() + 13, marginTop: "-3px" }}
                                                                    style={{ minHeight: "39px", marginTop: "-3px" }}
                                                                    onFocus={(e) => this.setState({ index: i.Id })}
                                                                    onChange={(e) => this.handleInputAdditionalTraining(e, i, 'Name', index)}
                                                                    onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                    value={i.Title && i.Title}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                            </div>
                                                            {(i.Title?.trim() != "" && this.state.existId?.includes(i.Id) == true) ?
                                                                <span className="pt-5 red-color">Training title is already exist</span> : <></>}
                                                            {(i.Title == "") ?
                                                                <span className="pt-5" style={{ color: '#DD0000' }}>Training title is required</span> : <></>}
                                                        </td>
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left align-middle`} style={{ minWidth: '49%', maxWidth: '49%' }}
                                                            onMouseEnter={(e) => this.setState({ HoverId1: i.Id })}
                                                            onMouseLeave={(e) => this.setState({ HoverId1: 0 })}
                                                        >
                                                            {(this.state.isDisabled == true || (this.state.HoverId1 == i.Id || this.state.FocusId1 == i.Id) || (i?.TrainingRoles?.length == 0 || i?.TrainingRoles?.length == undefined)) ?
                                                                <div
                                                                >
                                                                    <Select
                                                                        options={this.state.trainingsOptions || []}
                                                                        value={this.setDefaultTrainings(i.TrainingRoles)}
                                                                        placeholder=""
                                                                        classNamePrefix={"trainingsSelect"}
                                                                        menuPosition="fixed"
                                                                        menuPlacement="auto"
                                                                        isMulti={true}
                                                                        // id={"actDesc" + i.Id}
                                                                        isSearchable={true}
                                                                        onChange={(e) => this.trainingOnChange(e, i)}
                                                                        onFocus={(e) => this.setState({ FocusId1: i.Id })}
                                                                        onBlur={(e) => this.trainingChange(e, i)}
                                                                    // onBlur={(e) => this.setState({ FocusId1: 0 })}
                                                                    />
                                                                    {((i?.TrainingRoles?.length == 0 || i?.TrainingRoles?.length == undefined)) ?
                                                                        <span className="pt-5" style={{ color: '#DD0000' }}>Atleast one applicable role is required</span> : <></>}
                                                                </div> :
                                                                <div className="">
                                                                    {i?.TrainingRoles?.map((r, ind) => (
                                                                        ind == 0 ? r.RoleName : ", " + r.RoleName
                                                                    ))}
                                                                </div>
                                                            }
                                                        </td>
                                                        <td className="align-middle text-center border-right"><img src={Delete} className={this.state.isDisabled ? "img-disabled" : "cursorPointer"} onClick={() => { this.OpenPopup(i.Id) }} /></td>
                                                    </tr> : <></>
                                            ))}
                                                {this.state?.dataList?.CommonTrainings && this.state?.dataList?.CommonTrainings.map((i) => (
                                                    i.Id == 0 ?
                                                        <tr className="border-top">
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left align-middle`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <CssTextFieldLast
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id="actName"
                                                                    onChange={(e) => this.handleTrainingNameChange(e, i, 'Name')}
                                                                    onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                    value={this.state.name}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                                {((this.state.name.trim() == "" && this.state.typeId != 0 && this.state.nameError == true)) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Training title is required</span> : <></>}
                                                                {(this.state.name?.trim() != "" && this.state.existId?.includes(i.Id) == true) ?
                                                                    <span className="pt-5 red-color">Training title is already exist</span> : <></>}
                                                            </td>
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <Select
                                                                    options={this.state.trainingsOptions || []}
                                                                    disabled={this.state.isAccess == false ? true : false}
                                                                    placeholder=""
                                                                    classNamePrefix={"trainingsSelect"}
                                                                    menuPosition="fixed"
                                                                    menuPlacement="auto"
                                                                    isMulti={true}
                                                                    isSearchable={true}
                                                                    onChange={(e) => this.trainingChangePost(e, i)}
                                                                    onBlur={(e) => this.trainingChangePostBlur(e, i)}
                                                                    onFocus={(e) => this.setState({ FocusId1: i.Id })}
                                                                // onBlur={(e) => this.setState({ FocusId1: 0 })}
                                                                />
                                                                {((this.state.name.trim() != "" && this.state.typeId == 0 && this.state.nameError == true)) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Atleast one applicable role is required</span> : <></>}
                                                            </td>
                                                            <td className="align-middle text-center border-right">
                                                            </td>
                                                        </tr> : <></>
                                                ))}</> :
                                            <tr>
                                                <td className="border-top border-left border-right text-center align-middle" colSpan={3}><h6>No data to display</h6></td>
                                            </tr>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className={`${classes.paginationAlign}`}>
                        <div className={`${classes.paginationItem}`}>
                            {this.state.searchData.PageNumber == 1 ? <></> :
                                <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                            <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                            {(this.state.searchData.PageNumber == this.state.dataList?.pagination?.PageCount) || (this.state.dataList?.pagination?.PageCount == 0) ? <></> :
                                <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                        </div>
                    </div>

                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5></div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(LViewTrainings))
);
